import { render, staticRenderFns } from "./TeamStandings.vue?vue&type=template&id=4a8f4c64&scoped=true&"
import script from "./TeamStandings.vue?vue&type=script&lang=js&"
export * from "./TeamStandings.vue?vue&type=script&lang=js&"
import style0 from "./TeamStandings.vue?vue&type=style&index=0&id=4a8f4c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f4c64",
  null
  
)

export default component.exports